document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('ValeWaitlistForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"]');
      if (input && !input.checkValidity()) { e.preventDefault(); input.focus(); }
    });
  }

  var hero = document.querySelector('[data-vale-hero]');
  if (hero) { requestAnimationFrame(function(){ setTimeout(function(){ hero.classList.add('is-zoomed'); }, 80); }); }

  var reveals = document.querySelectorAll('.vale-magazine, .vale-macro-feature, .vale-packaging-story, .vale-performance, .vale-editorial, .vale-our-story, .vale-product-teaser, .vale-lifestyle, .vale-story-band');
  reveals.forEach(function(el){ el.classList.add('vale-reveal'); });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.vale-reveal').forEach(function(el){ observer.observe(el); });
  } else {
    document.querySelectorAll('.vale-reveal').forEach(function(el){ el.classList.add('is-visible'); });
  }
});
